"use strict";
// @ts-ignore
new Splide('.infinite-promo-splide', {
    perPage: 1,
    perMove: 1,
    type: 'loop',
    rewind: false,
    gap: "0px",
    padding: {
        left: "0%",
        right: "0%"
    },
    pagination: false,
    arrows: false,
    autoScroll: {
        speed: 1,
    },
    autoWidth: true,
    // @ts-ignore
}).mount(window.splide.Extensions);
